import usePageMeta from "../hooks/usePageMeta";
import { pageTitle } from "../lib/seo";

/* Wraps private/transactional routes (cart, checkout, login, admin) so they
   get a sensible title and a noindex tag without touching each page. */
function NoIndex({ title, children }) {
  usePageMeta({ title: pageTitle(title), noindex: true });
  return children;
}

export default NoIndex;
